import { exactProp } from '@mui/utils';
import { Ad, AdGuest } from '@mui/docs/Ad';
import RichMarkdownElement from 'docs/src/modules/components/RichMarkdownElement';
import AppLayoutDocs from 'docs/src/modules/components/AppLayoutDocs';
import { useUserLanguage } from '@mui/docs/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MarkdownDocs(props) {
  var _props$disableAd = props.disableAd,
    disableAd = _props$disableAd === void 0 ? false : _props$disableAd,
    _props$disableToc = props.disableToc,
    disableToc = _props$disableToc === void 0 ? false : _props$disableToc,
    _props$demos = props.demos,
    demos = _props$demos === void 0 ? {} : _props$demos,
    docs = props.docs,
    demoComponents = props.demoComponents,
    srcComponents = props.srcComponents;
  var userLanguage = useUserLanguage();
  var localizedDoc = docs[userLanguage] || docs.en;
  return /*#__PURE__*/_jsxs(AppLayoutDocs, {
    cardOptions: {
      description: localizedDoc.headers.cardDescription,
      title: localizedDoc.headers.cardTitle
    },
    description: localizedDoc.description,
    disableAd: disableAd,
    disableToc: disableToc,
    location: localizedDoc.location,
    title: localizedDoc.title,
    toc: localizedDoc.toc,
    children: [disableAd ? null : /*#__PURE__*/_jsx(AdGuest, {
      children: /*#__PURE__*/_jsx(Ad, {})
    }), localizedDoc.rendered.map(function (renderedMarkdownOrDemo, index) {
      return /*#__PURE__*/_jsx(RichMarkdownElement, {
        demoComponents: demoComponents,
        demos: demos,
        disableAd: disableAd,
        localizedDoc: localizedDoc,
        renderedMarkdownOrDemo: renderedMarkdownOrDemo,
        srcComponents: srcComponents
      }, "demos-section-".concat(index));
    })]
  });
}
false ? void 0 : void 0;
if (false) {
  false ? void 0 : void 0;
}